import { fetchWithSupabaseAuth } from "./supabaseClient.js";

export async function productUpdatesRequest(path, { method = "GET", body, signal } = {}) {
  const response = await fetchWithSupabaseAuth(`/api/product-updates${path}`, {
    method, signal, cache: "no-store",
    ...(body === undefined ? {} : { headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }),
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const detail = payload?.detail;
    const error = new Error(typeof detail === "string" ? detail : detail?.message
      || (Array.isArray(detail) ? detail.map(item => item.msg).join(" · ") : "Impossible de charger le Journal."));
    error.status = response.status;
    error.code = detail?.code;
    throw error;
  }
  return payload;
}

export const fetchPublishedUpdates = () => productUpdatesRequest("/published");
export const fetchProductUpdateAnnouncement = (signal) => productUpdatesRequest("/announcement", { signal });
export const dismissProductUpdateAnnouncement = (publications, closeMethod) => productUpdatesRequest("/announcement/dismiss", {
  method: "POST", body: { publications, close_method: closeMethod },
});
export const fetchJournalCaptureHistory = ({ page = 1, pageSize = 25 } = {}) => (
  productUpdatesRequest(`/announcement/history/captures?page=${page}&page_size=${pageSize}`)
);
export const productUpdateAction = (id, action, body) => productUpdatesRequest(`/publications/${encodeURIComponent(id)}/${action}`, { method: "POST", body });

export function formatPublicationDate(value) {
  return new Intl.DateTimeFormat("fr-CA", { dateStyle: "medium", timeStyle: "short", timeZone: "America/Toronto" }).format(new Date(value));
}
